import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import UnknownThumbHtmlView from './UnknownHtml';
import UnknownThumbReactView from './Unknown';
const UnknownThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(UnknownThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(UnknownThumbReactView, _extends({}, props));
};
UnknownThumbView.displayName = 'UnknownThumbView';
export default UnknownThumbView;
